import styled from "styled-components";
import { COLORS, responsive } from "../../../../../../../../../styles/constants.style";

export const SalesCreditDetailsTableWrapper = styled.div`
  .sales-credit-configuration-middle {
    margin: 24px 0px;

    ${responsive.MOBILE`
      margin: 16px 0px;
    `}
  }

  .sales-credit-configuration-add-button {
    margin-top: 24px;
    justify-content: flex-end;
    display: flex;
  }

  .MuiGrid2-root {
    padding-right: 0px;
  }

  .sales-credit-configuration-total-amount-percentage-container {
    display: flex;
    align-items: center;
  }

  .sales-credit-configuration-total-amount-percentage {
    padding: 4px 10px;
    margin-left: 8px;
    background-color: ${COLORS.cirrus_black2};
    border-radius: 4px;
  }

  .sales-credit-configuration-table {
    margin-top: 20px;
  }
`;
